<template>
  <div v-if="alert.status === 'success'">
    <Alert class="mt-2" status="success">
      {{ alert.message }}
    </Alert>
  </div>
  <FormContainer v-else-if="canCreateCompanies" @submitForm="addCompany">
    <div class="container-fluid">
      <div v-if="$oauth2.me.consultant && $oauth2.me.companiesLeft !== null" class="my-2">
        Aziende rimaste: <strong>{{ $oauth2.me.companiesLeft }}</strong>
      </div>
      <div class="row">
        <FormInputTextWidget
          class="col-12 col-md-6 col-lg-8"
          label="Ragione Sociale"
          placeholder="es. Google"
          v-model="company.name"
          :errorMsg="errorHash.name"
          @input="removeError('name')"
        />

        <FormInputTextWidget
          class="col-12 col-lg-4"
          label="Partita IVA"
          placeholder="es. 12345678910"
          v-model="company.vat"
          :errorMsg="errorHash.vat"
          @input="removeError('vat')"
        />

        <FormInputSelectWidget
          class="col-12"
          label="Consulente"
          v-model="company.consultant"
          v-if="this.$oauth2.me.admin && consultants.length"
          :options="consultantOptions"
          not-required
          optionValue="id"
          placeholder="Seleziona un consulente"
        />

        <div class="col-12">
          <FormInputCheckboxWidget
            v-model="privacy"
            :errorMsg="errorHash.privacy"
            @input="removeError('privacy')"
          >
            <template v-slot:label>
              Privacy &amp; GDPR
            </template>
            <p class="small text-muted">Dichiaro di conoscere ed accetto di applicare le condizioni contrattuali sottoscritte con la Mercurio s.r.l.s. nel rapporto con l'azienda individuata nel presente form, in particolare per quanto riguarda le condizioni previste dai paragrafi: utenze e livelli di accesso, corrispettivo, fatturazione e pagamenti, dichiarazioni e garanzie, responsabilità delle informazioni pubblicate, responsabilità di utilizzo della piattaforma, eventuali danni derivanti dall'utilizzo della piattaforma, responsabilità inadempimenti clienti, modalità di trattamento dei dati del cliente.</p>
          </FormInputCheckboxWidget>
        </div>
      </div>

      <div class="row mt-3 justify-content-end">
        <div class="d-none d-sm-block col-auto pr-0">
          <router-link :to="{ name: 'companies-index' }" class="btn btn-outline-secondary">Torna alle aziende</router-link>
        </div>
        <div class="col-auto">
          <button class="btn btn-primary">Registra azienda</button>
        </div>
      </div>
    </div>
  </FormContainer>
  <div v-else class="container-fluid">
    <div class="row mt-3">
      <p class="col-auto">
        Ha esaurito le aziende inseribili nel sistema. Contatti l'amministrazione per ulteriori informazioni.
      </p>
    </div>
      <div class="row mt-2 justify-content-end">
        <div class="d-none d-sm-block col-auto pr-3">
          <router-link :to="{ name: 'companies-index' }" class="btn btn-outline-secondary">Torna alle aziende</router-link>
        </div>
      </div>
  </div>

</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate.js';

export default {
  mixins: [validateMixin],
  components: {
    Alert: () => import('@/libs/Feedback/components/Alert.vue'),
    FormContainer: () => import('@/libs/Form/components/FormContainer.vue'),
    FormInputSelectWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputSelectWidget.vue'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget.vue'),
    FormInputCheckboxWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputCheckboxWidget.vue'),
  },
  props: {
    consultants: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      alert: {
        status: null,
        message: null,
      },
      company: {
        name: null,
        businessName: null,
        vat: null,
        consultant: undefined,
      },
      privacy: false,
    };
  },
  computed: {
    canCreateCompanies () {
      if (this.$oauth2.me.admin) {
        return true;
      }
      return this.$oauth2.me?.companiesLeft > 0 || this.$oauth2.me?.companiesLeft === null;
    },
    consultantOptions () {
      return (this.consultants || []).map(c => ({ ...c, label: `${c.name} ${c.surname}` }));
    },
  },
  methods: {
    isValid () {
      if (!this.company.name) {
        this.addError('Inserire Ragione Sociale', 'name');
      }

      if (!this.company.vat) {
        this.addError('Inserire P. IVA', 'vat');
      }

      if (!this.privacy) {
        this.addError('Privacy e GDPR obbligatoria', 'privacy');
      }

      return !this.hasErrors;
    },
    async addCompany () {
      if (!this.isValid()) {
        return;
      }

      this.$api.createCompany(this.company).then(res => {
        this.$emit('submit', res.data);
      }, this.$log.error);
    },
  },
  mounted () {
    this.$oauth2.getMe(true);
  },
};

</script>
